module.exports = DragonShared.ReactDOM;